import React from 'react';
import {Route} from 'react-router-dom';
import {has} from 'lodash-es';
import { routesConfig } from '../routesConfig';
import ErrorPage from '../layouts/ErrorPage';
import {get_random_guid} from '@Helpers/OtherHelper';
import PermissionDenied from '../layouts/PermissionDenied';

// eslint-disable-next-line react/prop-types
const ProtectedRoute = ({ component, pmCheck, permissions }) => {
	if (pmCheck && !pmCheck(permissions)) {
		return <PermissionDenied />;
	}
	
	return component;
};

export const getAuthRoutes = (permissions) => {
	const routes = routesConfig
		.filter(x => has(x, 'auth') && x.auth)
		.map((value) => {
			return (
				<Route 
					key={value.path} 
					path={value.path} 
					element={
						<ProtectedRoute 
							component={value.component} 
							pmCheck={value.pm}
							permissions={permissions}
						/>
					} 
				/>
			);
		});

	const finalRoutes = routes.length > 0 ? [
		...routes,
		<Route key={get_random_guid()} path="*" element={<ErrorPage />} />
	] : [];

	return finalRoutes;
};
